// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import { Text, Box } from '@nerdwallet/currency';
import parseMdLinks from '../../lib/parse-md-links';

const Step = ({ name, description, iconUri: uri }) => (
  <Box className="step nw-row__col-3">
    <Box
      className={(uri !== '' && 'step__content') || 'step__content--none'}
      style={{
        backgroundImage: uri && `url(${iconUri(uri)})`,
      }}
    >
      <Box className="step__title">
        <Text size="large">{name}</Text>
      </Box>
      <Box className="step__description">
        <Text component="p" size="small">
          {parseMdLinks(description)}
        </Text>
      </Box>
    </Box>
  </Box>
);

Step.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  iconUri: PropTypes.string,
};

Step.defaultProps = {
  name: 'Step',
  description: 'This is such a great step!',
  iconUri: '',
};

export default Step;
